import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import Field from './FieldValue';

import './DateField.scss';

export default function TextField({
  style,
  label,
  value,
  onChange,
  error,
  ...props
}) {
  console.log('value 123',value);
  return (
    <Field
      style={style}
      className="form-date-field"
      label={label}
      error={error}
    >
      <DatePicker
        selected={value && value!='Invalid date'?new Date(value):new Date()}
        onChange={(obj) => {
          onChange({ target: { value: moment(obj).format('YYYY-MM-DD') } });
        }}
        dateFormat="yyyy-MM-dd"
        placeholderText="YYYY-MM-DD"
        //maxDate={new Date("2100-12-31")}
        {...props}
      />
    </Field>
  );
}

TextField.propTypes = {
  style: PropTypes.shape(),
  label: PropTypes.string,
  value: PropTypes.node,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.node,
};

TextField.defaultProps = {
  style: {},
  label: '',
  value: '',
  error: null,
};
